import {api} from '../../../system/api';

export default {
    unlinkOrder: (code) => api.put("packages/" + code + "/unlink-order", {}, {singleRequest: true}),
};
